const LeftNavLogoSmall = ({ ...props }) => <img src="/storage/branding/logo-1-1.png" alt="logo" {...props} />;

export default LeftNavLogoSmall;
